import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.13 12c1.032 0 1.885-.843 1.724-1.863a12 12 0 0 0-9.99-9.991C12.842-.014 12 .838 12 1.87c0 1.033.848 1.85 1.855 2.082a8.259 8.259 0 0 1 6.192 6.192C20.28 11.152 21.096 12 22.13 12Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 0 0",
  to: "360 0 0",
  dur: "1.5s",
  repeatCount: "indefinite"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }